import { clsx } from 'clsx';
import * as React from 'react';

import styles from './ChatMessageMeta.css';
import { ChatPrettyDate } from '../ChatPrettyDate';

interface IChatMessageMetaProps {
  created: number;
  statusIcon: React.ReactNode;
}

export const ChatMessageMeta: React.FC<React.PropsWithChildren<IChatMessageMetaProps>> = ({ created, statusIcon }) => {
  return (
    <div className={styles['message__meta']} data-name="ChatMessageLayout_info">
      <ChatPrettyDate date={created} showOnlyTime containerStyles={clsx(styles['info_item'], styles['info_date'])} />

      {statusIcon && (
        <span className={styles['info_item']} data-name="ChatMessageLayout_status">
          {statusIcon}
        </span>
      )}
    </div>
  );
};
